<template>
  <div id="sign">
    <p class="title-second">
      需求发布流程
    </p>
    <process />
    <section class="mt-20">
      <publish-from :form="form"
                    :category-thir-code-opt="categoryThirCodeOpt"
                    :customized-type-opt="customizedTypeOpt"
                    :apply-number-opt="applyNumberOpt"
                    :division-account="divisionAccount"
                    :provider-opt="providerOpt"
                    :is-loading="isLoading"
                    modal="add"
                    @dataChange="dataChange"
                    ></publish-from>
    </section>
</div>
</template>
<script>
import UxMessage from '@cloud-sn/uxcool/es/message';
import { UxForm } from '@cloud-sn/uxcool';
import { customizedTypeOpt, categoryThirCodeOpt, applyNumberOpt } from './component/config';
import {squareService} from '../service';
import process from './component/process';
import publishFrom from './component/publish_form';

export default {
  components: {
    process,
    publishFrom
  },
  data() {
    return {
      labelCol: { sm: 4 },
      wrapperCol: { sm: 10 },
      agree: false,
      form: {
        "serverName": "",
        "customizedType": "",
        "categoryThirCode": "R9019522",
        "deadlineDate": null,
        "applyNumber": "",
        "deliverDate": null,
        "contactPhone": "",
        "description": "",
        "taskEnclosureUrl": "",
        "minBudget": "",
        "maxBudget": "",
        "signatureSign": "0",
        "providerArr": "",
        'fwsArr': [{value: ''}],
        "contactName": ""
      },
      divisionAccount: false, //事业部账号
      providerOpt: [],
      fileList: [],
      isLoading: false,
    }
  },
  created() {
    const self = this;
    this.customizedTypeOpt = customizedTypeOpt;
    this.categoryThirCodeOpt = categoryThirCodeOpt;
    this.applyNumberOpt = applyNumberOpt;
    this.getAccountInfo();
    this.getProviderInfo();
    UxForm.extendValidator('BudgetRule', {
      validate(value) {
        let flag = false;
        if(value !== '' && self.form.maxBudget !== '' ) {
          flag = true;
        }
        return flag;
      },
      getMessage(field) {
        return '初步预算金额必填';
      },
    })
  },
  methods: {
    getAccountInfo() {
      squareService.accountType().then((accountInfo) => {
        this.divisionAccount = accountInfo === '1';
      }, () => {
      });
    },
    getProviderInfo() {
      squareService.getProviderList().then((ProviderList) => {
        if(ProviderList && ProviderList.length > 0) {
          this.providerOpt = [];
          ProviderList.forEach((item) => {
            this.providerOpt.push({
              label: item.cmpyName,
              value: item.memberNo
            })
          })
        }
      }, () => {

      })
    },
    dataChange(data) {
      const{ deadlineDate, deliverDate, fwsArr, ...params} = data;
          params.deadlineDate = deadlineDate.Format('yyyy-MM-dd');
          params.deliverDate = deliverDate.Format('yyyy-MM-dd');
          if(data.customizedType === '3') {
            params.providerArr = this.formatfwsArr(fwsArr).join(',');
            params.applyNumber = ''
          }
          this.isLoading = true;
          squareService.publishTask(params).then((res) => {
            this.isLoading = false;
            if(res.success) {
              this.$router.push({name: 'success'})
            }
          }, (errMsg) => {
            this.isLoading = false;
            UxMessage.error(errMsg)
          })
    },
    submit() {
      const {
        $refs: { formRef },
      } = this;

      if(formRef) {
        formRef.validate().then(({ valid, values }) => {
          if (!valid) {
            return;
          }
          if(Number(this.form.maxBudget) > 100000 && this.form.fwsArr.length < 3 && this.divisionAccount) {
            UxMessage.error('最大金额超过10W，邀请服务商数量不小于3');
            return;
          }
          const{ deadlineDate, deliverDate, fwsArr, ...params} = this.form;
          params.deadlineDate = deadlineDate.Format('yyyy-MM-dd');
          params.deliverDate = deliverDate.Format('yyyy-MM-dd');
          if(this.form.customizedType === '3') {
            params.providerArr = this.formatfwsArr(fwsArr).join(',');
            params.applyNumber = ''
          }
          console.log(params, this.form, 'params');
          squareService.publishTask(params).then((res) => {
            console.log(res);
            if(res.success) {
              this.$router.push({name: 'success'})
            }
          }, () => {
            UxMessage.error('任务提交失败')
          })
        });
      }
    },
    formatfwsArr(fwsArr) {
      const temp = [];
      fwsArr.forEach((item) => {
        temp.push(item.value)
      })
      return temp;
    },
  }
}
</script>
<style scoped>
#sign {
  padding: 20px;
  background: #fff;
}
.budgetText {
  /* display: inline-block;
  margin: 0 10px; */
  text-align: center;
}
.budget-wrapper >>> .ux-form-explain {
  color: #f5222d;
}
</style>